import angular from "angular";
import panel from "../services";
import GooglePay from "../lib/GooglePay";
import CreditCard from "../lib/CreditCard";
import braintree from 'braintree-web';

function appPaymentPlans (panel) {

    return {
        restrict: 'E',
        scope: {
            user: '='
        },
        link: (scope, element) => {
            scope.display = true;
            scope.plans = [];
            scope.current_plan = {};
            scope.cc = {};

            $(element).click((e) => {
                if (scope.display) {
                    $(element).removeClass('hide');
                }
                scope.display = true;
            });
            let url = '/v1/membership/getPlans';

            panel.get(url, (response) => {
                scope.plans = response.plans;
            });

            scope.submitPayment = () => {
                let fields = ['fullname', 'number', 'exp_date', 'cvc'];
                let __class = 'missing-info';
                let errors = [];

                for(let i in fields) {
                    let f = fields[i];
                    let el = $('.cc-'+f);
                    if (!scope.cc[f]) {
                        errors.push(f);
                        el.addClass(__class);
                    } else {
                        el.removeClass(__class);
                    }
                }

                if(errors.length > 0) {
                    return;
                }

                panel.post('/v1/membership/processPayment', scope.cc, (response) => {

                })
            };

            scope.createHostedFields = (clientInstance) => {
                braintree.hostedFields.create({
                        client: clientInstance,
                        styles: {
                            'input': {
                                'font-size': '16px',
                                'font-family': 'courier, monospace',
                                'font-weight': 'lighter',
                                'color': '#ccc',
                                'height': '40px'
                            },
                            ':focus': {
                                'color': 'black'
                            },
                            '.valid': {
                                'color': '#000000'
                            }
                        },
                        fields: {
                            number: {
                                selector: '#cardNumber'
                            },
                            cvv: {
                                selector: '#securityCode'
                            },
                            expirationDate: {
                                selector: '#expirationDate'
                            },
                            postalCode: {
                                selector: '#postalCode'
                            }
                        }
                    },

                    (err, hostedFieldsInstance) => {
                        if(err) {
                            // console.log(err);
                            return;
                        }

                        let form = '#cc-payment-form';

                        hostedFieldsInstance.on('validityChange', function (event) {
                            // Check if all fields are valid, then show submit button
                            var formValid = Object.keys(event.fields).every(function (key) {
                                return event.fields[key].isValid;
                            });

                            if (formValid) {
                                $('#button-pay').addClass('show-button');
                            } else {
                                $('#button-pay').removeClass('show-button');
                            }
                        });

                        hostedFieldsInstance.on('empty', function (event) {
                            $('header').removeClass('header-slide');
                            $('#card-image').removeClass();
                            $(form).removeClass();
                        });

                        hostedFieldsInstance.on('cardTypeChange', function (event) {
                            // Change card bg depending on card type
                            if (event.cards.length === 1) {
                                $(form).removeClass().addClass(event.cards[0].type);
                                $('#card-image').removeClass().addClass(event.cards[0].type);
                                $('header').addClass('header-slide');

                                // Change the CVV length for AmericanExpress cards
                                if (event.cards[0].code.size === 4) {
                                    hostedFieldsInstance.setAttribute({
                                        field: 'cvv',
                                        attribute: 'placeholder',
                                        value: '1234'
                                    });
                                }
                            } else {
                                hostedFieldsInstance.setAttribute({
                                    field: 'cvv',
                                    attribute: 'placeholder',
                                    value: '123'
                                });
                            }
                        });

                        let payButton = document.getElementById('button-pay');

                        let processPayment = () => {

                            hostedFieldsInstance.tokenize( function (err, payload) {
                                if(err) {
                                    // console.log(err);
                                    return;
                                }

                                panel.post('/v1/membership/subscribe', {payload: payload, order_id : scope.order_id}, (response) => {

                                });

                                alert('Submit your nonce to your server here!');
                            });

                            // hostedFieldsInstance.teardown( function () {
                            //     scope.createHostedFields(clientInstance);
                            //     payButton.removeEventListener('click', (e) => {e.preventDefault(); processPayment();}, false);
                            // });
                        };

                        payButton.addEventListener('click', (e) => {e.preventDefault();processPayment();}, false);
                });
            };

            scope.redirectPayment = (plan) => {
                scope.current_plan = plan;
                panel.post('/v1/membership/order', {plan_id:plan.id}, (response) => {
                    scope.order_id = response.order_id;
                    if(response.processor  === 'braintree') {
                        braintree.client.create({
                            authorization: response.auth.token
                            },

                            (err, clientInstance) => {
                                if (err) {
                                    console.error(err);
                                    return;
                                }

                                scope.createHostedFields(clientInstance);
                        });
                    }

                    let cc = CreditCard('#credit-card-payment');

                    $('.payment-plan-tabs .view-tab').addClass('hide');
                    $('.tab-selected').removeClass('hide');

                    if (!scope.gpay) {
                        scope.gpay = new GooglePay();
                    }
                    scope.gpay.registerEvent(scope.gpay.event.PAYMENT_PROCESSED, (payload) => {
                        // console.log(payload, 'posted data here fam');
                    });
                    scope.gpay.setContainer();
                    let totalPriceStatus = 'FINAL', totalPrice = 1, currencyCode = 'USD', countryCode = 'CA';
                    scope.gpay.setGoogleTransactionInfo(totalPriceStatus, totalPrice, currencyCode, countryCode);
                }, (error) => {
                    // console.log(error);
                });
            };

            scope.getColor = (icon) => {
                let colors = {
                    'bronze':'#cd7f32',
                    'silver':'silver',
                    'gold':'gold',
                    'platinum':'silver'
                };
                return colors[icon];
            }

            scope.cancel = () => {
                scope.display = false;
                $('.app-payment-plans').addClass('hide');
            }

            scope.back = (className) => {
                $('.payment-plan-tabs .view-tab').addClass('hide');
                $('.'+className).removeClass('hide');
            }

            scope.next = () => {

            }
        },
        template: require('./templates/app-payment-plans.html')
    }
};

export default angular.module('directives.appPaymentPlans', [panel]).directive('appPaymentPlans', appPaymentPlans).name;



// WEBPACK FOOTER //
// ./src/app/directives/appPaymentPlans.js